import React from "react";
import { ISignupModalProps } from "./SignupModalProps";
import Modal from "react-bootstrap/Modal";
import { StyledModal } from "./SignupModalHelpers";
import SignupForm from "../SignupForm/SignupForm";
import Container from "react-bootstrap/Container";
import { graphql, useStaticQuery } from "gatsby";

const SignupModal: React.FC<ISignupModalProps> = (props) => {
  const data = useStaticQuery(graphql`
    query SignupModal {
      page: nodePage(path: { alias: { eq: "/join-travel-pass" } }) {
        id
        title
        field_meta_description
        body {
          value
        }
      }
    }
  `);
  return (
    <StyledModal {...props}>
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body className="show-grid">
        <Container fluid="sm" className="pt-5 px-1 px-lg-5 pb-3">
          <SignupForm onSignUp={props.onHide} body={data?.page?.body?.value} />
        </Container>
      </Modal.Body>
      <Modal.Footer></Modal.Footer>
    </StyledModal>
  );
};
export default SignupModal;
